import { isTestOrLocalDb } from "shared/itops/shared/util";
export type RateLimitConfig = {
  disabled: boolean;
} | {
  seconds: number;
  tokens: number;
};

export const featureFlagKeys = [
  'archie-templates-access',
  'archie-triage-access',
  'archie-triage-follow-up-questions',
  'archie-canvas',
  'archie-apps',
  'archie-word-web-access',
  'archie-chat-rate-limit',
  'archie-diverse-retrieval',
  'archie-kl-retrieval',
  'archie-llm-thinking',
  'archie-llm-thinking-displayed',
  'archie-billing-retrieval',
  'archie-templates-max-actions',
  'archie-request-advanced-extraction',
  'archie-auto-advanced-extraction',
  'archie-expand-optimizable-filetypes',
  'archie-confirm-specific-files',
  'integrations-lawy',
  'archie-law-y'
] as const;

export type FeatureFlagKey = typeof featureFlagKeys[number];

// Feature flags that are boolean values only (excludes JSON/complex types)
export type BooleanFeatureFlags = Exclude<FeatureFlagKey, 'archie-chat-rate-limit'>;

export type FeatureFlags = {
  [k in Exclude<FeatureFlagKey, 'archie-chat-rate-limit' | 'archie-templates-max-actions' | 'archie-expand-optimizable-filetypes'>]: boolean | undefined;
} & {
  'archie-chat-rate-limit': RateLimitConfig | undefined;
  'archie-templates-max-actions': number;
  'archie-expand-optimizable-filetypes': string;
};

export const defaultFeatureFlagsTestOrLocalDb: FeatureFlags = {
  'archie-templates-access': true,
  'archie-triage-access': true,
  'archie-triage-follow-up-questions': true,
  'archie-canvas': false,
  'archie-apps': false,
  'archie-word-web-access': true,
  'archie-chat-rate-limit': { seconds: 60, tokens: 1000 },
  'archie-diverse-retrieval': true,
  'archie-kl-retrieval': true,
  'archie-llm-thinking': true,
  'archie-llm-thinking-displayed': true,
  'archie-billing-retrieval': false,
  'archie-templates-max-actions': 10,
  'archie-request-advanced-extraction': false,
  'archie-auto-advanced-extraction': false,
  'archie-expand-optimizable-filetypes': '.pdf',
  'archie-confirm-specific-files': false,
  'integrations-lawy': false,
  'archie-law-y': false,
} as const;


export const defaultFeatureFlags: FeatureFlags = {
  'archie-templates-access': false,
  'archie-triage-access': false,
  'archie-triage-follow-up-questions': false,
  'archie-canvas': false,
  'archie-apps': false,
  'archie-word-web-access': false,
  'archie-chat-rate-limit': { disabled: true },
  'archie-billing-retrieval': false,
  'archie-diverse-retrieval': false,
  'archie-kl-retrieval': false,
  'archie-llm-thinking': false,
  'archie-llm-thinking-displayed': false,
  'archie-templates-max-actions': 10,
  'archie-request-advanced-extraction': false,
  'archie-auto-advanced-extraction': false,
  'archie-expand-optimizable-filetypes': '.pdf',
  'archie-confirm-specific-files': false,
  'integrations-lawy': false,
  'archie-law-y': false,
} as const;

export const getDefaultFeatureFlag = <T extends FeatureFlagKey>(flag: T): FeatureFlags[T] =>
  isTestOrLocalDb() ? defaultFeatureFlagsTestOrLocalDb[flag] : defaultFeatureFlags[flag];
